module.exports = __webpack_public_path__ + "static/benefits-145cf13252492c8852be1ab78a0cab58.png";